import { API, ApiPrefixes } from "../../api";

const SETTINGS = ApiPrefixes["adminSettings"];
const BRANCHES = ApiPrefixes["adminBranchSettings"];

export const memberSlotExtendedApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getMemberSlotCapacity: builder.query({
      query: () => ({
        url: `${SETTINGS}/member-slots?guard=staff`,
      }),
      transformResponse: (responseData) => responseData.data,
      providesTags: ["MemberSlotCapacity"],
    }),
    updateMemberSlotAllocation: builder.mutation({
      query: ({ branchId, member_slot_allocation }) => ({
        url: `${BRANCHES}/${branchId}/member-slot-allocation?guard=staff`,
        method: "PATCH",
        body: { member_slot_allocation },
      }),
      invalidatesTags: ["MemberSlotCapacity", "Branch"],
    }),
  }),
});

export const {
  useGetMemberSlotCapacityQuery,
  useUpdateMemberSlotAllocationMutation,
} = memberSlotExtendedApi;
